/**
 * Generato automaticamente.
 * framework-cmp-domande
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient.ts';
import type { ErrorType } from '../../../client/apiClient.ts';
import type { TipoUtenteDTO } from '../schemas/tipoUtenteDTO.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Ottiene l'elenco delle sezioni di un modulo.
 * @summary Elenco sezioni di un modulo
 */
export const getFrontTipiUtente = (
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<TipoUtenteDTO[]>(
    { url: `/framework-cmp-domande/tipi-utente`, method: 'get', signal },
    options,
  );
};

export const getGetFrontTipiUtenteQueryKey = () =>
  [`/framework-cmp-domande/tipi-utente`] as const;

export const getGetFrontTipiUtenteQueryOptions = <
  TData = Awaited<ReturnType<typeof getFrontTipiUtente>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getFrontTipiUtente>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryOptions<
  Awaited<ReturnType<typeof getFrontTipiUtente>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFrontTipiUtenteQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFrontTipiUtente>>
  > = ({ signal }) => getFrontTipiUtente(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetFrontTipiUtenteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFrontTipiUtente>>
>;
export type GetFrontTipiUtenteQueryError = ErrorType<unknown>;

/**
 * @summary Elenco sezioni di un modulo
 */
export const useGetFrontTipiUtente = <
  TData = Awaited<ReturnType<typeof getFrontTipiUtente>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getFrontTipiUtente>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFrontTipiUtenteQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
